import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-630af380"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-4xl text-secondary font-extrabold text-center lg:pt-16" }, "Sınırları Kaldıran Kolay Yatırım", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "max-w-5xl mx-auto text-2xl text-primary text-center py-6" }, " Dünya genelinde gayrimenkul yatırımı yapmak artık online alışveriş kadar kolay. Karmaşık evrak işleriyle uğraşmaya gerek kalmadan, blokzincir teknolojisi ile hızlı ve güvenli yatırım yapın. ", -1))
const _hoisted_3 = { class: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-12" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "absolute flex items-center justify-center p-4 bg-secondary text-white rounded-t-lg" }, " YAKINDA ", -1))
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "p-5" }
const _hoisted_7 = { class: "flex flex-row justify-between" }
const _hoisted_8 = { class: "mb-2 text-2xl font-bold tracking-tight text-primary" }
const _hoisted_9 = { class: "mb-2 text-lg font-bold tracking-tight text-secondary" }
const _hoisted_10 = { class: "mb-3 font-normal text-gray-700" }
const _hoisted_11 = { class: "flex flex-col justify-between pb-6" }
const _hoisted_12 = { class: "text-sm font-medium text-gray-900" }
const _hoisted_13 = { class: "text-sm font-medium text-gray-900" }
const _hoisted_14 = { class: "flex flex-row justify-between" }
const _hoisted_15 = { class: "text-xs font-medium text-gray-900" }
const _hoisted_16 = { class: "text-xs font-medium text-gray-900" }
const _hoisted_17 = { class: "flex flex-row justify-between" }
const _hoisted_18 = { class: "text-xs font-medium text-gray-900" }
const _hoisted_19 = { class: "text-xs font-medium text-gray-900" }
const _hoisted_20 = { class: "flex flex-row justify-between items-center mt-4" }
const _hoisted_21 = { class: "font-bold text-center pt-4" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "#waitlist",
  class: "inline-flex items-center px-3 py-2 mt-4 text-sm font-medium text-center text-white bg-secondary rounded-lg hover:bg-primary"
}, [
  /*#__PURE__*/_createTextVNode(" Yatırım yap "),
  /*#__PURE__*/_createElementVNode("svg", {
    class: "rtl:rotate-180 w-3.5 h-3.5 ms-2",
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 10"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M1 5h12m0 0L9 1m4 4L9 9"
    })
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.assets, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "relative bg-white border border-gray-200 rounded-lg shadow-sm"
        }, [
          _hoisted_4,
          _createElementVNode("img", {
            class: "rounded-t-lg opacity-15",
            src: item.img,
            alt: ""
          }, null, 8, _hoisted_5),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("h5", _hoisted_8, _toDisplayString(item.name), 1),
              _createElementVNode("h5", _hoisted_9, _toDisplayString(item.total_supply) + " Bloqs ", 1)
            ]),
            _createElementVNode("p", _hoisted_10, _toDisplayString(item.description), 1),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("span", _hoisted_12, " Konum: " + _toDisplayString(item.location), 1),
              _createElementVNode("span", _hoisted_13, " Mülk Tipi: " + _toDisplayString(item.type), 1)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("span", _hoisted_15, " İlk Değerleme: " + _toDisplayString(_ctx.formatPrice(Number(item.initial_valuation), item.country)), 1),
              _createElementVNode("span", _hoisted_16, " Son Değerleme: " + _toDisplayString(_ctx.formatPrice(Number(item.current_valuation), item.country)), 1)
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("span", _hoisted_18, " İlk fiyat: " + _toDisplayString(_ctx.formatPrice(Number((item.initial_valuation / item.total_supply).toFixed(2)), item.country)) + " / Bloq ", 1),
              _createElementVNode("span", _hoisted_19, " Son Fiyat: " + _toDisplayString(_ctx.formatPrice(Number((item.current_valuation / item.total_supply).toFixed(2)), item.country)) + " / Bloq ", 1)
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("h2", _hoisted_21, _toDisplayString(_ctx.formatPrice(Number((item.current_valuation / item.total_supply)), item.country)) + " / Bloq", 1),
              _hoisted_22
            ])
          ])
        ]))
      }), 128))
    ])
  ], 64))
}